var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcDental = function SvgIcDental(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.944 14.848C3.61 7.62.289 8.397 1.141 3.707c.851-4.69 6.109-1.86 7.27-1.86 1.16 0 6.644-2.83 7.437 1.86.794 4.69-1.78 4.202-1.78 8.3 0 4.098-.087 8.993-2.166 8.993-2.078 0-1.39-3.75-1.39-6.152s-.837-3.06-2.102-3.06c-1.264 0-2.212.48-2.212 4.339 0 3.86-.004 4.873-1.296 4.873s-2.198-3.548-1.958-6.152Z",
    stroke: "#6B6C72",
    strokeWidth: 2,
    fill: "none",
    fillRule: "evenodd"
  })));
};
export default SvgIcDental;